import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { ArrowRight, Briefcase, FileText } from 'react-feather';
import { Navbar } from './Navbar';

/* The 404 page. Even a dead end should point somewhere useful. */

const NotFound = () => {
    const navigate = useNavigate();
    const signedIn = !!Cookies.get('access_token');
    const home = signedIn ? '/home' : '/';

    return (
        <>
        <Navbar />
        <div className="min-h-screen bg-gradient-to-b from-sky-50 via-blue-50/40 to-white flex items-center justify-center px-6">
            <motion.div
                className="text-center max-w-lg"
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <p className="text-7xl sm:text-8xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-sky-500">
                    404
                </p>
                <h1 className="mt-3 text-2xl font-extrabold text-gray-900 tracking-tight">
                    This page does not exist.
                </h1>
                <p className="mt-2 text-gray-600">
                    The link may be old, or the page may have moved. Your work is
                    all still here, and so are the jobs.
                </p>
                <div className="mt-8 flex flex-wrap justify-center gap-3">
                    <button
                        onClick={() => navigate(home)}
                        className="inline-flex items-center gap-2 bg-blue-600 text-white font-bold px-6 py-3 rounded-xl hover:bg-blue-500 shadow-lg shadow-blue-600/20 transition"
                    >
                        Take me home <ArrowRight className="w-4 h-4" />
                    </button>
                    {signedIn ? (
                        <button
                            onClick={() => navigate('/auto-apply')}
                            className="inline-flex items-center gap-2 bg-white text-gray-800 font-semibold px-6 py-3 rounded-xl border border-gray-300 hover:border-blue-400 hover:text-blue-700 transition"
                        >
                            <Briefcase className="w-4 h-4" /> Open Auto-Apply
                        </button>
                    ) : (
                        <button
                            onClick={() => navigate('/features')}
                            className="inline-flex items-center gap-2 bg-white text-gray-800 font-semibold px-6 py-3 rounded-xl border border-gray-300 hover:border-blue-400 hover:text-blue-700 transition"
                        >
                            <FileText className="w-4 h-4" /> See what we do
                        </button>
                    )}
                </div>
            </motion.div>
        </div>
        </>
    );
};

export default NotFound;
